var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "lead mb-0", attrs: { id: "filter-chips-list-title" } },
        [_c("strong", { domProps: { innerHTML: _vm._s(_vm.title) } })]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass:
            "ob1-filterchip d-flex align-items-start flex-column d-lg-block",
          attrs: {
            "data-ob1-component": "Chips",
            role: "group",
            "aria-labelledby": "filter-chips-list-title",
          },
        },
        [
          _vm._l(_vm.chipsList, function (chips, index) {
            return [
              _c("ob1-chips-button-element", {
                key: index,
                staticClass: "mb-1 me-lg-2",
                attrs: {
                  label: chips.label,
                  "aria-controls": _vm.linkedWithResults
                    ? "total-mobiles"
                    : null,
                  "is-active": chips.checked,
                },
                on: {
                  "ob1-chips-click": function ($event) {
                    return _vm.clickHandler(chips.id, $event)
                  },
                },
              }),
            ]
          }),
        ],
        2
      ),
      _vm._v(" "),
      _vm.inlineAlert
        ? _c("ob1-message-alerte", {
            attrs: { type: "info", title: _vm.inlineAlert },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("hr", { staticClass: "separator separator--gray4" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }